import React, { useState, useRef, useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  Chip,
  Box,
  Popover
} from '@mui/material';
import dayjs from 'dayjs';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const OverviewFilters = ({ selectedLocations, period_comparison_options, selectedPeriodComparison, locationOptions, onFilterConditionChange, dateRange }) => {




  const autocompleteFieldStyles = {
    "& .MuiInputLabel-root": { fontSize: '12px' },
    "& input": { fontSize: '12px' },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderWidth: '1px',
      },
      "&:hover fieldset": {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      "&.Mui-focused fieldset": {
        borderColor: 'primary.main',
      }
    }
  };


  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const dateInputRef = useRef(null);

  // Initialize filters on component mount
  useEffect(() => {
    sendFiltersToParent(selectedLocations, selectedPeriodComparison, dateRange.startDate, dateRange.endDate);
  }, []);

  const handleLocationChange = (event, newValues) => {
    sendFiltersToParent(newValues, selectedPeriodComparison, dateRange.startDate, dateRange.endDate);
  };

  const handlePeriodComparisonChange = (event, newValue) => {
    sendFiltersToParent(selectedLocations, newValue, dateRange.startDate, dateRange.endDate);
  };

  const handleDateRangeChange = (ranges) => {
    const newRange = ranges.selection;

    sendFiltersToParent(selectedLocations, selectedPeriodComparison, newRange.startDate, newRange.endDate);
  };

  const handleDateInputClick = () => {
    setDatePickerOpen(true);
  };

  const handleDatePickerClose = () => {
    setDatePickerOpen(false);
  };

  const sendFiltersToParent = (locations, periodComparison, startDate, endDate) => {
    onFilterConditionChange(
      locations,
      periodComparison,
      startDate,
      endDate
    );
    
  };

  const formatDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return '';
    return `${dayjs(startDate).format('MMM DD, YYYY')} - ${dayjs(endDate).format('MMM DD, YYYY')}`;
  };

  const login = () => {}
  const register = () => {}

  return (
    <>
      
      <div className="react-class-filter" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
        {/* Location Autocomplete - Multiple Selection */}
        <Box sx={{ minWidth: '200px', flex: 1 }}>
          <Autocomplete
            multiple
            options={locationOptions || []}
            getOptionLabel={(option) => option}
            value={selectedLocations || []}
            onChange={handleLocationChange}
            renderTags={(values, getTagProps) =>
              values.map((option, index) => (
                <Chip
                  key={index}
                  variant="outlined"
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Location"
                placeholder={selectedLocations?.length ? "" : "Select locations"}
                sx={autocompleteFieldStyles}
              />
            )}
          />
        </Box>

        {/* Period Comparison Autocomplete - Single Selection */}
        <Box sx={{ minWidth: '200px', flex: 1 }}>
          <Autocomplete
            options={period_comparison_options || []}
            getOptionLabel={(option) => option?.label || ""}
            value={selectedPeriodComparison}
            onChange={handlePeriodComparisonChange}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Period Comparison"
                placeholder="Select period comparison"
                sx={autocompleteFieldStyles}
              />
            )}
          />
        </Box>

        {/* <Box sx={{ minWidth: '200px', flex: 1 }}>
          <Autocomplete
            options={[{label: 'Happy Hour Promotion'}, {label: 'Birthday Promotion'}]}
            getOptionLabel={(option) => option?.label || ""}
            value={""}
            onChange={()=> {}}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Marketing Campaign"
                placeholder="Marketing Campaign"
                sx={autocompleteFieldStyles}
              />
            )}
          />
        </Box> */}

        {/* Date Range Input Field */}
        <Box sx={{ minWidth: '250px', flex: 1 }}>
          <TextField
            ref={dateInputRef}
            variant="outlined"
            label="Date Range"
            value={formatDateRange(dateRange.startDate, dateRange.endDate)}
            onClick={handleDateInputClick}
            readOnly
            sx={{
              ...autocompleteFieldStyles,
              cursor: 'pointer',
              '& .MuiInputBase-input': {
                cursor: 'pointer'
              }
            }}
            fullWidth
          />
          
          {/* Date Range Picker Popover */}
          <Popover
            open={datePickerOpen}
            anchorEl={dateInputRef.current}
            onClose={handleDatePickerClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              sx: {
                mt: 1,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(0, 0, 0, 0.12)'
              }
            }}
          >
            <DateRangePicker
              ranges={[dateRange]}
              onChange={handleDateRangeChange}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              direction="horizontal"
              maxDate={new Date()}
            />
          </Popover>
        </Box>
      </div>
    </>
  );
};

export default OverviewFilters;